import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  Avatar,
  useMediaQuery,
  styled,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Header from "./header";
import ProfileImg from "../assets/user.png";
import {palette, theme as colorTheme}  from "../Convoze.theme"



/* ----------  route location pathname for title and subtitle ---------- */

const pageMeta = [
  {
    pattern: /^\/user\/audio-analytics\//,
    meta: {
      title: "Audio Analytics",
      subtitle: "Analyze your Audio Analytics here",
    },
  },

  /* exact paths */
  {
    pattern: /^\/user\/dashboard$/,
    meta: {
      title: "Dashboard",
      subtitle: "Overview of all the interactions and insights",
    },
  },
  {
    pattern: /^\/user\/dashboard2$/,
    meta: {
      title: "Dashboard",
      subtitle: "Overview of all the interactions and insights",
    },
  },
  {
    pattern: /^\/user\/audio-details$/,
    meta: {
      title: "Interactions",
      subtitle:
        "Conversations and call recordings uploaded on convoze platform",
    },
  },
  {
    pattern: /^\/user\/leaderboard$/,
    meta: {
      title: "LeaderBoard",
      subtitle: "Have comparative analysis of all your agents",
    },
  },
  {
    pattern: /^\/user\/agent\/list$/,
    meta: {
      title: "Agents Overview",
      subtitle: "Manage and monitor your team of agents",
    },
  },
  {
    pattern: /^\/user\/user-management$/,
    meta: {
      title: "User Management",
      subtitle: "Manage call-center agents, managers, and administrators",
    },
  },
  {
    pattern: /^\/user\/training$/,
    meta: {
      title: "Training Activation",
      subtitle: "Upload your QA SOP and activate 72-hour AI training",
    },
  },
  {
    pattern: /^\/user\/billing$/,
    meta: {
      title: "Billing Dashboard",
      subtitle: "Monitor your AI Speech Analytics usage and billing",
    },
  },
  {
    pattern: /^\/user\/setting$/,
    meta: {
      title: "My Profile",
      subtitle: "Personal details and account settings",
    },
  },
  {
    pattern: /^\/user\/settings$/,
    meta: { title: "Security Settings", subtitle: "Manage your account here" },
  },
  {
    pattern: /^\/user\/account\/manage$/,
    meta: {
      title: "Account Management",
      subtitle: "Manage your complete account here",
    },
  },
  {
    pattern: /^\/user\/audio$/,
    meta: {
      title: "Upload Audio",
      subtitle: "Upload audio for instant conversation review",
    },
  },
  {
    pattern: /^\/agent\/dashboard$/,
    meta: { title: "Agent Dashboard", subtitle: "View performance of Agents" },
  },
    {
    pattern: /^\/user\/agent-profile\//,
    meta: {
      title: "Agent Profile",
      subtitle: "Analyze your Agent Profile",
    },
  },
  {
    pattern: /^\/agent\/my-calls$/,
    meta: { title: "Call Analytics", subtitle: "View analysis of your calls" },
  },
  {
    pattern: /^\/agent\/my-kpis$/,
    meta: { title: "My KPIs", subtitle: "Analyze your KPIs here" },
  },
  {
    pattern: /^\/agent\/leaderboard$/,
    meta: { title: "Agent Leaderboard", subtitle: "View performance of Agents" },
  },
  {
    pattern: /^\/agent\/settings$/,
    meta: { title: "Agent Settings", subtitle: "Agent settings" },
  },
   {
    pattern: /^\/super-admin\/process-management$/,
    meta: { title: "Process Management", subtitle: "" },
  },
  {
    pattern: /^\/super-admin\/client-management$/,
    meta: { title: "Client Management", subtitle: "" },
  }
];

const defaultMeta = { title: "", subtitle: "" };

const getMeta = (path) => {
  const hit = pageMeta.find((p) => p.pattern.test(path));
  return hit ? hit.meta : defaultMeta;
};

const primary = colorTheme('palette', 'primary').value;


export default function Topbar() {
  const { pathname } = useLocation();
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : {};
  const isMobile = useMediaQuery("(max-width:600px)");

  const meta = getMeta(pathname);

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={(t) => ({
        backgroundColor: "rgba(255,255,255,0.72)",
        backdropFilter: "blur(12px)",
        borderBottom: "1px solid rgba(0,0,0,0.06)",
        zIndex: 999,
      })}
    >
      <Toolbar
        variant="dense"
        sx={{
          minHeight: 44,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          // backgroundColor:'red'
        }}
      >
        <Header title={meta.title} subtitle={meta.subtitle} />

        <Box sx={{ display: "flex", alignItems: "center", gap: 1  }}>
          {
            <Box sx={{ lineHeight: 1 }}>
              <Typography
                sx={{
                  fontSize: {
                    xs: "0.625rem",
                    sm: "0.6875rem",
                    md: "0.75rem",
                    lg: "0.75rem",
                    xl: '0.77rem'
                  },
                  fontWeight: 500,
                  color: "rgba(0,0,0,.78)",
                }}
              >
                {decodedToken?.userName || ""}
              </Typography>
              <Typography
                sx={{
                  fontSize: {
                    xs: '0.5625rem',  
                    sm: '0.625rem',  
                    md: '0.6875rem',  
                    lg: '0.6875rem',   
                    xl:'0.77rem'
                  },
                  fontWeight: 600,
                  color: primary
                }}
              >
                {decodedToken?.userRole || ""}
              </Typography>
            </Box>
          }
          <Avatar
            src={ProfileImg}
            sx={{
              width: 26,
              height: 26,
              boxShadow: "0 0 0 1px rgba(0,0,0,.06)",
            }}
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
}
